import { Box, Typography, Grid, Stack, Card, CardMedia, CardContent, useTheme, useMediaQuery, Link } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { About, Careers, CompanyMenuCard, ContactUs } from '../assets';
import { map } from 'lodash';
import MenuLinkWithIcon from './MenuLinkWithIcon';
import { useNavigate } from 'react-router-dom';
import { AppBarMenuButtonContext } from './app-bar-menu-button';
import { PopperNavigationContext } from '..';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

const resources = [
    {
        icon: About,
        title: "companyMenu.about.title",
        subtitle: "companyMenu.about.description",
        href: "/about"
    },
    {
        icon: Careers,
        title: "companyMenu.careers.title",
        subtitle: "companyMenu.careers.description",
        href: "/contact-us"
    },
    {
        icon: ContactUs,
        title: "companyMenu.contact.title",
        subtitle: "companyMenu.contact.description",
        href: "/contact-us"
    },
]

const links = [
    {
        title: "footer.links.privacyPolicy",
        href: "/privacy",
    },
    // {
    //     title: "footer.links.conditions",
    //     href: "/terms-and-conditions",
    // },
    {
        title: "footer.links.documentation",
        href: "/documentation",
    },
]

const CompanyMenu = ({ ...props }) => {

    const { t } = useTranslation('public');
    const navigate = useNavigate();

    const appBarContext = useContext(AppBarMenuButtonContext);
    const popperContext = useContext(PopperNavigationContext);

    console.log('appBarContext', appBarContext)
    console.log('popperContext', popperContext)

    const theme = useTheme();
    const isDownMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={{ paddingInlineStart: 4, paddingInlineEnd: 6, paddingBlock: 2, maxWidth: isDownMd ? "100%" : "920px" }}>
            <Stack direction={isDownMd ? "column" : "row"}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={7.5}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Typography sx={{ color: "#1E1E1E", fontSize: '16px', fontStyle: 'normal', fontWeight: 500, lineHeight: '130%', mb: 1 }}>
                                {t("Company")}
                            </Typography>
                            <Box>
                                {
                                    map(
                                        resources,
                                        resource => <MenuLinkWithIcon link={resource} sx={{ marginBlock: 2 }} />
                                    )
                                }
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4.5}>
                        <Typography sx={{ color: "#1E1E1E", fontSize: '16px', fontStyle: 'normal', fontWeight: 500, lineHeight: '130%', mb: 1 }}>
                            {t("More")}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            {
                                map(links, link => (
                                    <Link
                                        key={link?.title}
                                        onClick={() => {
                                            appBarContext?.handleClose()
                                            popperContext?.closePopperMenu()
                                            navigate(link?.href)
                                        }}
                                        sx={{ textDecoration: 'none', mt: "20px", color: "#1E1E1E", fontSize: '16px', fontWeight: 400, cursor: "pointer" }}>
                                        {t(link.title)}
                                    </Link>
                                ))
                            }
                        </Box>
                    </Grid>
                </Grid>
                <Box ml={isDownMd ? '' : "80px"} mt={isDownMd ? "20px" : ''}>
                    <Card sx={{ width: isDownMd ? "100%" : 300 }}>
                        <CardMedia component="div" sx={{ float: 'none', clear: 'both' }}>
                            <LiteYouTubeEmbed
                                id="HC2qmLWao0w"
                                title="Mapit Last Mile Tech Solutions"
                            />
                        </CardMedia>
                        <CardContent>
                            <Typography
                                sx={{
                                    color: "#1E1E1E",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    lineHeight: "20.80px",
                                }}>
                                {t("companyMenu.video.title")}
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#1E1E1E",
                                    fontSize: "14px",
                                    fontWeight: "300",
                                }}
                            >
                                {t("companyMenu.video.subtitle")}
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
            </Stack>
        </Box >
    );
}

export default CompanyMenu;
